import React from 'react';
import { styled, Typography } from '@material-ui/core';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.page.fontColor,
  fontSize: 24,
  lineHeight: '32px',
  letterSpacing: 0.15,
  fontWeight: 700,
  fontFamily: 'Red Hat Display',
  margin: 0,
}));

export const PageTitle = ({ children }: { children: React.ReactNode }) => {
  return <StyledTypography variant="h1">{children}</StyledTypography>;
};
